import {StyleSheet} from 'react-native';

export const styles = StyleSheet.create({
  inline: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
});
